var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2EditAContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.88 59v4H13.22v-4h49.66zM26 51.56l-11.76 4.12 2.64-11.91 30.25-35c1.64-1.77 4.87-1.4 7.3.85 2.43 2.25 3 5.23 1.67 7L26 51.56zm-2.92-2.37L19.34 46l-1.12 3.68c.37.04.72.194 1 .44a1.9 1.9 0 01.51.67l3.35-1.6zM25.33 45l26.85-30.73-2.27-2L23.07 43l2.26 2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Edit_a_content.d3284e79.svg";
export { SvgJ2EditAContent as ReactComponent };